import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LectureTypeEnum } from 'src/app/submit-lecture/lecture.values';

@Component({
  selector: 'classification',
  templateUrl: './classification.component.html',
  styleUrls: ['./classification.component.scss'],
})
export class ClassificationComponent implements ICellRendererAngularComp {
  refresh;
  type: string;
  private params: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.type = this.params.data?.type;
  }

  isPaid = (): boolean => {
    if (this.type === LectureTypeEnum.PAID) {
      return true;
    }
    return false;
  }

}
